import React, { useEffect, useState } from "react";
import {
  option1,
  option2,
  option3,
  option4,
  option5,
  option6,
  options,
  recurrium,
} from "./constant";
import { Button, ButtonContainer, Table } from "./style";
import { DonationPagesDescription } from "../PageLayout";
import { Payment } from "../Payment/donationTable";

export const RecurriumDonation = () => {
  const [selectedOption, setSelectedOption] = useState("");

  const handleOptionClick = (value: React.SetStateAction<string>) => {
    setSelectedOption(value);
  };

  const renderTable = () => {
    if (selectedOption === "option1") {
      return (
        <Table>
          <Payment
            donationCategories={option1}
            donationPageName={"Monthly Anna Daan"}
          />
        </Table>
      );
    }

    if (selectedOption === "option2") {
      return (
        <Table>
          <Payment
            donationCategories={option2}
            donationPageName={"Monthly Gau Seva"}
          />
        </Table>
      );
    }

    if (selectedOption === "option3") {
      return (
        <Table>
          <Payment
            donationCategories={option3}
            donationPageName={"Monthly Sadhu Bhojan"}
          />
        </Table>
      );
    }
    if (selectedOption === "option4") {
      return (
        <Table>
          <Payment
            donationCategories={option4}
            donationPageName={"Monthly Vidya Daan"}
          />
        </Table>
      );
    }
    if (selectedOption === "option5") {
      return (
        <Table>
          <Payment
            donationCategories={option5}
            donationPageName={"Monthly Youth Preaching Seva"}
          />
        </Table>
      );
    }
    if (selectedOption === "option6") {
      return (
        <Table>
          <Payment
            donationCategories={option6}
            donationPageName={"Monthly temple support"}
          />
        </Table>
      );
    }

    return null;
  };
  useEffect(() => {
    // Set a default option when the component is first mounted
    handleOptionClick("option1");
  }, []); // Empty dependency array to run this effect only once

  return (
    <>
      <DonationPagesDescription
        title="Support Seva This Month"
        content={recurrium}
      />
      <ButtonContainer>
        {options.map((option) => (
          <div key={option.value}>
            <Button
              className={`Button ${
                selectedOption === option.value ? "active-button" : ""
              }`}
              onClick={() => handleOptionClick(option.value)}
            >
              {option.label}
            </Button>
          </div>
        ))}
      </ButtonContainer>

      {renderTable()}
    </>
  );
};
